module.exports = __webpack_public_path__ + "img/active-img.6cf5619b.png";